import { useState, useCallback, useRef } from 'react';
import useStateStorage from '../../storage/stateStorage';

type CollapsedSectionsMap = Record<string, boolean>;

export default function useCollapsibleSectionState(pageContext?: string) {
  const storageKey = pageContext ? `collapsible-sections-${pageContext}` : '';
  const storage = useStateStorage<CollapsedSectionsMap>(storageKey);
  const storageRef = useRef(storage);
  storageRef.current = storage;

  const [collapsedSections, setCollapsedSections] = useState<CollapsedSectionsMap>(
    () => (pageContext ? storage.getValue({}) : {})
  );

  const isCollapsed = useCallback((sectionId: string): boolean => {
    return collapsedSections[sectionId] ?? false;
  }, [collapsedSections]);

  const toggleSection = useCallback((sectionId: string) => {
    if (!pageContext) return;

    const currentStoredState = storageRef.current.getValue({});
    const newState = {
      ...currentStoredState,
      [sectionId]: !currentStoredState[sectionId],
    };

    storageRef.current.setValue(newState);
    setCollapsedSections(newState);
  }, [pageContext]);

  return {
    isCollapsed,
    toggleSection,
  };
}
